module.exports = __webpack_public_path__ + "img/gb-nir.9d02a9ef.svg";